class SportFilter {
    constructor(){
        this.tablist = document.querySelector("#filterlist")
        if (!this.tablist) return  
        this.tabpanel = document.querySelectorAll(".filterpanel")
        this.activeTotal = document.querySelector(".active-total")
        this.addEvents()
    }

    addEvents(){
        this.tablist.addEventListener("click", (e) => {
            const button = e.target.closest("button")
            if (!button) return

            // If already active → stop
            if (button.dataset.state === "active") return

            // Remove active state from all buttons
            this.tablist.querySelectorAll("button").forEach(btn => {
                btn.dataset.state = "inactive"
            })

            // Set clicked button to active
            button.dataset.state = "active"

            // Send AJAX request
            this.loadTabContent(button.dataset.term)
        })
    }

    loadTabContent(selectedPanel){
        let count = 0;
        this.tabpanel.forEach(panel => {
            console.log("selectedPanel : ",selectedPanel)
            if(selectedPanel != "all"){
               if(selectedPanel != "indoor-outdoor"){
                    if (panel.dataset.term === selectedPanel) {
                        //panel.dataset.state = "active"
                        panel.classList.remove("hidden")
                        count++
                    } else {
                        //panel.dataset.state = "inactive"
                        if(panel.dataset.term == "indoor-outdoor"){
                            panel.classList.remove("hidden")
                            count++
                        }else{
                            panel.classList.add("hidden")
                        }
                        
                    }
                }else{
                     if (panel.dataset.term === selectedPanel) {
                        //panel.dataset.state = "active"
                        panel.classList.remove("hidden")
                        count++
                    } else {
                        //panel.dataset.state = "inactive"
                        panel.classList.add("hidden")
                    }
                }
            }else{
                panel.classList.remove("hidden")
                count++
            }
            
        })
        console.log("count : ", count)
        this.activeTotal.innerHTML = count
    }
}

export default SportFilter